import { combineReducers } from 'redux';

import editIngredient from './editingredient/reducer';
import removeReplaceIngredient from './removereplaceingredient/reducer';

export default combineReducers({
  editIngredient,
  removeReplaceIngredient,
});



// WEBPACK FOOTER //
// ./src/pages/manageingredient/state/reducers.js